module.exports = __webpack_public_path__ + "img/8.43dedd69.jpg";